"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CHAIN_CONFIGS", {
  enumerable: true,
  get: function () {
    return _chainConfigs.CHAIN_CONFIGS;
  }
});
Object.defineProperty(exports, "CHAIN_NAMES", {
  enumerable: true,
  get: function () {
    return _chainConfigs.CHAIN_NAMES;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "generateKeystore", {
  enumerable: true,
  get: function () {
    return _generateKeystore.default;
  }
});
Object.defineProperty(exports, "getBLSToExecution", {
  enumerable: true,
  get: function () {
    return _blsToExecution.getBLSToExecution;
  }
});
Object.defineProperty(exports, "getSecretKeyFromKeystore", {
  enumerable: true,
  get: function () {
    return _verifyKeystore.getSecretKeyFromKeystore;
  }
});
Object.defineProperty(exports, "keystoreToBLSExecution", {
  enumerable: true,
  get: function () {
    return _blsToExecution.keystoreToBLSExecution;
  }
});
Object.defineProperty(exports, "mnemonicToBLSExecution", {
  enumerable: true,
  get: function () {
    return _blsToExecution.mnemonicToBLSExecution;
  }
});
Object.defineProperty(exports, "pubKeyToWithdrawalCredential", {
  enumerable: true,
  get: function () {
    return _blsToExecution.pubKeyToWithdrawalCredential;
  }
});
Object.defineProperty(exports, "verifyKeystore", {
  enumerable: true,
  get: function () {
    return _verifyKeystore.verify;
  }
});
var bip39 = _interopRequireWildcard(require("bip39"));
var _blsHdKey = require("@chainsafe/bls-hd-key");
var _bls = require("@chainsafe/bls");
var _generateKeystore = _interopRequireDefault(require("./generateKeystore"));
var _verifyKeystore = require("./verifyKeystore");
var _blsToExecution = require("./blsToExecution");
var _chainConfigs = require("./chainConfigs");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class Keystore {
  constructor() {
    let {
      mnemonic = '',
      password = '',
      bits = 256,
      lang = 'english'
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    bip39.setDefaultWordlist(lang);
    if (mnemonic === '') {
      mnemonic = bip39.generateMnemonic(bits);
    }
    this.mnemonic = mnemonic;
    this.bits = bits;
    this.seed = bip39.mnemonicToSeedSync(mnemonic, password);
    this.masterKey = (0, _blsHdKey.deriveMasterSK)(this.seed);
  }
  async getEntropy() {
    return bip39.mnemonicToEntropy(this.mnemonic);
  }
  async getSeed() {
    return this.seed;
  }
  async getMnemonic() {
    return this.mnemonic;
  }
  async getPath() {
    let idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let isSigning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const withdrawalPath = `m/12381/3600/${idx}/0`;
    return isSigning ? withdrawalPath + '/0' : withdrawalPath;
  }
  async getChildKey() {
    let idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let isSigning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const path = await this.getPath(idx, isSigning);
    return (0, _blsHdKey.deriveChildSKMultiple)(this.masterKey, (0, _blsHdKey.pathToIndices)(path));
  }
  async getPublicKey() {
    let idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let isSigning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    await (0, _bls.init)('herumi');
    return Buffer.from(_bls.SecretKey.fromBytes(await this.getChildKey(idx, isSigning)).toPublicKey().toBytes());
  }
  async toSigningKeystore(password) {
    let idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const childKey = await this.getChildKey(idx, true);
    const path = await this.getPath(idx, true);
    return (0, _generateKeystore.default)(childKey, password, params, path);
  }
  async toWithdrawalKeystore(password) {
    let idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const childKey = await this.getChildKey(idx, false);
    const path = await this.getPath(idx, false);
    return (0, _generateKeystore.default)(childKey, password, params, path);
  }
  async getSigningSecretKey() {
    let idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return this.getChildKey(idx, true);
  }
  async getWithdrawalSecretKey() {
    let idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return this.getChildKey(idx, false);
  }
}
var _default = Keystore;
exports.default = _default;